// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1FElt","author":"Table_author__2zs8c","authorImage":"Table_authorImage__3QHAZ","unreadRow":"Table_unreadRow__2oXrG"};